import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface DeleteConfirmationProps {
  CancelButtonText?: string;
  ConfirmDelete: (Id: string) => void;
  DeleteButtonText?: string;
  HideModal: () => void;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  Id: any;
  Message: string;
  ShowModal: boolean;
  Title?: string;
}

const DeleteConfirmation = ({
  CancelButtonText = 'Peruuta ja sulje',
  ConfirmDelete,
  DeleteButtonText = 'Poista',
  HideModal,
  Id,
  Message,
  ShowModal,
  Title = 'Poiston varmistaminen',
}: DeleteConfirmationProps) => {
  return (
    <Modal show={ShowModal} centered>
      <Modal.Body className="px-24 py-40 px-lg-40">
        <h3 className="h4 mb-16">{Title}</h3>
        <p className="mb-0">{Message}</p>
      </Modal.Body>
      <Modal.Footer className="border-0 bg-light p-24">
        <Button variant="link" onClick={() => HideModal()} className="px-32">
          {CancelButtonText}
        </Button>
        <Button
          variant="danger"
          onClick={() => ConfirmDelete(Id)}
          className="px-32"
        >
          {DeleteButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// DeleteConfirmation.defaultProps = {
//   CancelButtonText: 'Peruuta ja sulje',
//   DeleteButtonText: 'Poista',
//   Title: 'Poiston varmistaminen',
// };

export default DeleteConfirmation;
export { DeleteConfirmation };
export type { DeleteConfirmationProps };
